import CryptoJS from "crypto-js";
import HtmlToReact from "html-to-react";
export const Per_Page_Dropdown = async (data) => {
  const a = [];
  for (let i = 5; i <= data; i *= 2) {
    a.push(i);
  }
  a.push(data);

  return a;
};

export const RequiredIs = {
  roles: [1, 2, 3, 4, 5, 6, 7],
};

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const getDimension = async (file) => {
  let reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      var image = new Image();
      image.src = reader.result;
      image.onload = function() {
        resolve({ width: this.width, height: this.height });
      };
    };
    reader.readAsDataURL(file);
  });
};

export const RegxExpression = {
  name: /[A-Z-a-z ]/,
  email: /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
  phone: /[0-9]/,

  ifsc: "^[A-Z]{4}[0][dA-Z]{6}$",
  ifsc_code: /^[A-Z0-9]$/,
  micr: /^[0-9]{9}$/,
  bank_number: /^\d{0,14}$/,
  gst: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[1-9A-Z]{1}$/,
};

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
}

export const IDS = {
  // IMG_URL: "http://127.0.0.1:1515",

   IMG_URL: "https://hindustansolarnode.profcymadev.com:1518",
   
  Payment_Mode: {
    Online: "online",
    COD: "cod",
    Wallet: "wallet",
  },
  order_status: {
    Ordered: 1,
    Processing: 2,
    Shipped: 3,
    Deliverd: 5,
    Cancelled: 4,
    Returned: 6,
  },
  return_status: {
    ReturnRequested: 1,
    ReturnApproved: 2,
    ProductPicked: 3,
    Returned: 4,
    RefundProcess: 5,
    Refunded: 6,
    ReturnRejected: 7,
  },
};

export function formatCustomDate(dateString) {
  const date = new Date(dateString);

  const day = date.getDate();

  // suffix (st, nd, rd, th)
  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
      ? "nd"
      : day % 10 === 3 && day !== 13
      ? "rd"
      : "th";

  const months = [
    "Jan.",
    "Feb.",
    "Mar.",
    "Apr.",
    "May.",
    "Jun.",
    "Jul.",
    "Aug.",
    "Sep.",
    "Oct.",
    "Nov.",
    "Dec.",
  ];

  const month = months[date.getMonth()];
  const year = date.getFullYear(); // ✅ year added

  let hours = date.getHours();
  let minutes = date
    .getMinutes()
    .toString()
    .padStart(2, "0");

  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12;

  const finalTime = `${hours.toString().padStart(2, "0")}:${minutes} ${ampm}`;

  return `${day}${suffix} ${month} ${year} | ${finalTime}`;
}

const SECRET_KEY = "local-djfhgdkjfghdjkflghdjklf";
export const encodeId = (id) => {
  if (!id) return "";
  const ciphertext = CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
  return encodeURIComponent(ciphertext); // Make URL-safe
};

export const decodeId = (encodedId) => {
  if (!encodedId) return "";
  try {
    const decoded = decodeURIComponent(encodedId);
    const bytes = CryptoJS.AES.decrypt(decoded, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Invalid ID decryption:", error);
    return "";
  }
};
